import { forwardRef } from 'react';
import { Button as HeroButton, type ButtonProps as HeroButtonProps } from '@heroui/react';

/**
 * Design-system Button. Thin wrapper over HeroUI Button that pins our defaults
 * (radius, font weight) so feature code never sets raw HeroUI styling. Use the
 * `color`/`variant`/`size` props exactly as HeroUI's.
 */
export type ButtonProps = HeroButtonProps;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className, radius = 'md', ...props }, ref,
) {
  return <HeroButton ref={ref} radius={radius} className={className} {...props} />;
});
